export default __webpack_public_path__ + "static/headstand-bodycenter-header-e5079007cac42a989c3d47e97a8f8721.png";